export default class transition {
    constructor(manager,concept) {

        //manager
        this.manager = manager;
        this.conceptManager = concept;

    }
    init(){
        for(let i in this.conceptManager.$linkList) {
            if (this.conceptManager.$linkList[i].nodeType != 1) continue; // dom要素以外は処理止める
            this.conceptManager.$linkList[i].querySelector('a').addEventListener("click",()=>{
                this.conceptManager.status.current = i;
            });
        }
    }
    out(){

        setTimeout(()=>{
            for(let i in this.conceptManager.$linkList) {
                if (this.conceptManager.$linkList[i].nodeType != 1) continue; // dom要素以外は処理止める

                TweenMax.killTweensOf(this.conceptManager.$linkList[i]);

                if(i == this.conceptManager.status.current){
                    TweenMax.to(this.conceptManager.$linkList[i], 1.6 ,{
                        delay: 0.7,
                        opacity:0,
                        ease: Power2.easeOut,
                    });
                    TweenMax.to(this.conceptManager.$linkList[i], 1.8 ,{
                        delay: 0.7,
                        scale: 1.02,
                        ease: Power2.easeOut,
                        onComplete: () => {
                            TweenMax.to(this.conceptManager.$linkWrap, .1 ,{
                                opacity:0,
                            });
                        }
                    });
                }else{
                    TweenMax.to(this.conceptManager.$linkList[i], 1.2 ,{
                        opacity:0,
                        scale:0.96,
                        ease: Power2.easeOut
                    });
                }
            }
            TweenMax.to(this.conceptManager.$title,1.6, {
                delay: .7,
                opacity: 0,
                ease: this.manager.ease,
            });
        },1e2);

        // ------------ spの時フッターを非表示
        if(this.manager.param.displayType == 'sp'){
            TweenMax.to('#l-footer_sp', .6 ,{
                delay:0.3,
                opacity:0,
                ease: Power2.easeOut
            });
        }

    }
    in(){

        //set
        TweenMax.set(this.conceptManager.$title,{
            opacity:0
        });

        TweenMax.to(this.conceptManager.$title,1.2,{
            delay:.8,
            opacity:1,
            ease:this.manager.ease,
            onComplete: () => {
                this.set();
            }
        });
        // ------------ spの時フッターを表示
        if(this.manager.param.displayType == 'sp'){
            TweenMax.to('#l-footer_sp', .6 ,{
                delay:0.3,
                opacity:1,
                ease: Power2.easeOut
            });
        }

    }
    detailOut() {

        TweenMax.to(this.conceptManager.$photo,1.6, {
            opacity: 0,
            scale:0.97,
            ease: this.manager.ease,
        });
        TweenMax.to(this.conceptManager.$detail,1.6, {
            opacity: 0,
            ease: this.manager.ease,
        });

        // ------------ spの時フッターを非表示
        if(this.manager.param.displayType == 'sp'){
            TweenMax.to('#l-footer_sp', .6 ,{
                delay:0.3,
                opacity:0,
                ease: Power2.easeOut
            });
        }

    }
    detailIn(){

        //set
        TweenMax.set(this.conceptManager.$photo,{
            scale:1.08,
            rotation:1,
            opacity:0,
            width:'100vw',
        });
        TweenMax.set(this.conceptManager.$detail,{
            opacity:0,
            y:'30px',
        });

        //motion
        TweenMax.to(this.conceptManager.$photo,1.6, {
            rotation: 0,
            ease:this.manager.ease,
        });
        TweenMax.to(this.conceptManager.$photo,2.6,{
            scale:1,
            opacity:1,
            ease:this.manager.ease,
            onStart: () => {
                TweenMax.to(this.conceptManager.$waku, 1.6,{
                    delay:2.2,
                    x:'20px',
                    y:'20px',
                    width:'105%',
                    height:'100%',
                    ease: Power3.easeOut,
                    onStart: () => {
                        if(!(Useragnt.mobile || (this.manager.isIpad && this.manager.portrait))){
                            TweenMax.to(this.conceptManager.$photo, 1.6, {
                                width: this.manager.isIpad ? window.innerWidth * 0.625 + 'px' : '62.5vw',
                                ease: Power3.easeOut,
                                onStart: () => {
                                    TweenMax.to(this.conceptManager.$detail, 1.4, {
                                        delay:1.1,
                                        opacity:1,
                                        y:'0px',
                                        ease: this.manager.ease
                                    });
                                }
                            });
                            if(this.conceptManager.$photo.classList.contains('center-basis')){//中央基準のものはずらす
                                TweenMax.to(this.conceptManager.$photoList[0], 1.6,{
                                    x:'-18%',
                                    ease: Power3.easeOut
                                });
                            }
                        }else{
                            TweenMax.to(this.conceptManager.$detail, 1.4, {
                                delay:.3,
                                opacity:1,
                                y:'0px',
                                ease: this.manager.ease
                            });
                        }
                    }
                });
            }
        });
        // ------------ spの時フッターを表示
        if(this.manager.param.displayType == 'sp'){
            TweenMax.to('#l-footer_sp', .6 ,{
                delay:0.3,
                opacity:1,
                ease: Power2.easeOut
            });
        }

    }
    set(){ //スクロール一位置よって要素表示

        for(let i in this.manager.scroll.contents.point){

            if(this.manager.scroll.contents.point[i].start<this.manager.scroll.inc+window.innerHeight/2){

                if(this.manager.scroll.contents.status.show[i]) continue;
                this.manager.scroll.contents.status.show[i] = true;
                setTimeout(()=> {
                    if (this.manager.scroll.contents.$text[i]) this.manager.effect.text(this.manager.scroll.contents.$text[i], "show");
                },i * 250);

            }
        }

    }
}